import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons/faPaperPlaneTop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import { usePlateEditorState } from '@udecode/plate';

import Button from 'components/common/button';
import isEditorEmpty from 'components/text_editor_new/lib/is_editor_empty';

export default function Send({ id, onSubmit }) {
  const editor = usePlateEditorState();

  return (
    <StyledSend disabled={isEditorEmpty(editor)} onClick={onSubmit} onMouseDown={evt => evt.preventDefault()}>
      <FontAwesomeIcon icon={faPaperPlaneTop} />
    </StyledSend>
  );
}

export const StyledSend = styled(Button)`
  margin-top: 4px;
  padding: 4px 12px;
`;
